import React, { forwardRef } from 'react';
import { SvgIcon, SvgIconProps } from '@mui/material';

/**
 * Flow brand exclusive icon
 */
export const FileFilledIcon: React.FC<SvgIconProps> = forwardRef((props, ref) => {
  return (
    <SvgIcon viewBox="2 2 20 20" ref={ref} {...props}>
      <path d="M13.52 4.08L18.18 8.74V19.84H5.82V4.08H13.52ZM12.82 9.44H16.76L12.82 5.5V9.44Z" />
    </SvgIcon>
  );
});
